import React from 'react';
import Config from './modules/config';
import SgfUtil from './modules/sgf/sgfUtil';
import T from './modules/translation';

class VariationTable extends React.Component {
  constructor(props) {
    super(props);
    this.handleNumberChange = this.handleNumberChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.state = {
      numOfVariations: Config.getInstance().numOfVariations
    }
  }

  onSelect(event) {
    this.props.onChange(parseInt(event.target.value));
  }

  handleNumberChange(event) {
    const num = parseInt(event.target.value);
    Config.getInstance().numOfVariations = num;
    this.setState({
      numOfVariations: num
    })
  }

  getTBody() {
    const boardSize = this.props.boardSize;
    const variations = this.props.prediction.variations;
    if (!variations.length) {
      return null;
    }
    const visitSum = variations.reduce((a, b) => a + b.visit, 0);
    const validSelection = variations.filter(
      (_, i) => i < this.state.numOfVariations)
      .some(variation => variation.index === this.props.selected);
    const selected = validSelection ? this.props.selected : -1;
    return variations.filter((_, i) => i < this.state.numOfVariations)
      .filter(variation => variation.visit > visitSum / boardSize / boardSize * 2)
      .map((variation, i) => {
        let gtpVertex;
        if (variation.index === this.props.prediction.visits.length - 1) {
          gtpVertex = "PASS";
        } else {
          gtpVertex = SgfUtil.indexToGtpVertex(variation.index, boardSize);
        }
        return (
          <tr key={i}>
            <td>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio"
                  name="variation" id={variation.index}
                  value={variation.index}
                  onChange={this.onSelect}
                  checked={variation.index === selected}
                />
                <label className="form-check-label">{String.fromCharCode(65 + i)}</label>
              </div>
            </td>
            <td>{gtpVertex}</td>
            <td>{variation.visit}</td>
            <td>{variation.winRate.toFixed(1)}%</td>
          </tr>
        );
      });
  }

  render() {
    if (!this.props.prediction || this.props.viewMode !== "variation") {
      return null;
    }
    let options = [];
    for (let i = 1; i <= 10; i++) {
      options.push(<option key={i} value={i}>{i}</option>);
    }
    return (
      <div>
        <div className="table-responsive variation-table mt-2">
          <table className="table table-condensed table-striped table-bordered">
            <thead>
              <tr>
                <th colSpan="2">{T.get("move")}</th>
                <th>{T.get("visits")}</th>
                <th>{T.get("winRate")}</th>
              </tr>
            </thead>
            <tbody>
              {this.getTBody()}
            </tbody>
          </table>
        </div>
        <div className="numOfVariations-container row g-1 justify-content-end mb-2">
          <div className="col-auto">
            <label htmlFor="numOfVariations">{T.get("numOfVariations")}</label>
          </div>
          <div className="col-auto">
            <select id="numOfVariations" className="form-select form-select-sm"
              aria-label="number of variations"
              value={this.state.numOfVariations}
              onChange={this.handleNumberChange}>
              {options}
            </select>
          </div>
        </div>
      </div>
    );
  }
}

export default VariationTable;